export const SERVICE_TYPES = [
  "Aplicación de medicamentos / inyecciones",
  "Curaciones y cuidado de heridas",
  "Cuidado de adulto mayor",
  "Cuidado postoperatorio",
  "Toma de signos vitales / muestras",
  "Cuidados paliativos",
  "Acompañamiento hospitalario",
  "Cuidado de paciente con discapacidad",
  "Otro",
];

export const URGENCY_OPTIONS = [
  { value: "urgente", label: "Urgente (hoy mismo)" },
  { value: "pronto", label: "Pronto (esta semana)" },
  { value: "normal", label: "Normal (próximos días)" },
];
